import { Box, Text, VStack, HStack, Badge } from '@chakra-ui/react'
import { Building2, FileText } from 'lucide-react'
import type { Residence } from '@/features/properties/types'

interface ResidenceCardProps {
  residence: Residence
  documentCount?: number
  onClick: () => void
}

export function ResidenceCard({ residence, documentCount = 0, onClick }: ResidenceCardProps) {
  return (
    <Box
      borderWidth="1px"
      borderRadius="lg"
      p={6}
      bg="white"
      cursor="pointer"
      transition="all 0.2s"
      _hover={{
        borderColor: 'brand.500',
        boxShadow: 'md',
        transform: 'translateY(-2px)',
      }}
      onClick={onClick}
    >
      <VStack align="stretch" gap={4}>
        <HStack justify="space-between">
          <Box
            p={3}
            borderRadius="md"
            bg="brand.50"
            borderWidth="1px"
            borderColor="brand.100"
          >
            <Building2 size={24} color="#3182CE" />
          </Box>
          {residence.residence_key && (
            <Badge colorPalette="brand" variant="subtle">
              {residence.residence_key}
            </Badge>
          )}
        </HStack>

        <VStack align="stretch" gap={2}>
          <Text fontSize="md" fontWeight="semibold" color="gray.800" lineClamp={2}>
            {residence.name}
          </Text>

          <HStack gap={2} color="gray.600">
            <FileText size={14} />
            <Text fontSize="sm">
              {documentCount} document{documentCount !== 1 ? 's' : ''}
            </Text>
          </HStack>
        </VStack>
      </VStack>
    </Box>
  )
}
